import { Flex, Text } from "@chakra-ui/react";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function TitleFlex({ item }: any) {
  const colors = useRecoilState(customColors)[0];

  return (
    <Flex mx={2} mt={4} mb={3} borderBottom={`solid 3px ${colors.BLUEMONEDDBUTTONS}`}>
      <Text color={colors.BLUEMONEDDBUTTONS} fontWeight={"bold"}>
        {item && item}
      </Text>
    </Flex>
  );
}
